import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import { TableBookings, FilterBookings } from "./sections";
import { FormProvider, useForm } from "react-hook-form";
import {IFormValuesBookingsFilter} from "./types";
import {useSearchParams} from "react-router-dom";

const BookingSearchPage = () => {

    const { t } = useTranslation('booking');

    const [searchParams] = useSearchParams();

    const form = useForm<IFormValuesBookingsFilter>({
        defaultValues: {
            pickupLocations: [],
            dropoffLocations: [],
            statusList: [],
            substatusList: [],
            bookingDateFrom: null,
            bookingDateTo: null,
            pickupDateFrom: null,
            pickupDateTo: null,
            dropoffDateFrom: null,
            dropoffDateTo: null,
            effectiveBookingDateFrom: null,
            effectiveBookingDateTo: null,
            createdBy: '',
            rentalDaysFrom: 0,
            rentalDaysTo: 0,
            bookingNumber: '',
            customerCode: '',
            dossierNumber: '',
            driverFirstName: '',
            driverLastName: '',
            bookingOwnerFirstName: '',
            bookingOwnerLastName: '',
            bookingOwnerCompanyName: '',
            vehicleTypes: [],
            acrissList: [],
            sippList: [],
            segments: [],
            categories: [],
            products: [],
            rates: [],
            subscriptionNumber: '',
            renewal: null,
            licensePlateNumber: '',
            replacementPlateNumber: '',
            substitution: null,
            ancillaries: [],
            rentwayNumber: '',
            affiliationCode: '',
            salesChannels: [],
            customerId: searchParams.get('customerId') ?? '',
            customerAtDesk: true,
            hideDrafts: true,
            businessAgreements: [],
            keyless: '',
            rce: ''
        },
    });

    return (
        <>
            <FormProvider {...form}>
                <SectionHeader title={t('label.bookingSearch')} />
                <Stack rowGap={3} p={3}>
                    <FilterBookings />
                    <TableBookings />
                </Stack>
            </FormProvider>
        </>
    );
}

export default BookingSearchPage;
